'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z' });

var PowerInput = function PowerInput(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

PowerInput = (0, _pure2.default)(PowerInput);
PowerInput.muiName = 'SvgIcon';

exports.default = PowerInput;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/PowerInput.js
// module id = 2738
// module chunks = 0